

function getTopologyKey(topology) {
    return JSON.stringify(topology.flat(Infinity).sort());
}

const extractIsobars = (topology, IsobarObj) => {
    if (Array.isArray(topology)) {
        IsobarObj[getTopologyKey(topology)] = {label: getTopologyKey(topology), resonances: {}, tuple: topology.flat(Infinity).sort()};
        topology.forEach((subTopology) => {
            extractIsobars(subTopology, IsobarObj);
        });
    }
};

const particleContent = (topology) => {
    return topology.flat(Infinity);
}

const replace = (topology, toReplace, replaceWith) => {
    const newTopology = topology.flat(Infinity).sort();
    const index = newTopology.indexOf(toReplace);
    if (index !== -1) {
        newTopology[index] = replaceWith;
    }
    return newTopology;
}

function generateUniqueVariants(baseList, groups) {
  // Build mapping: value -> its group (array of possible replacements)
  const mapping = new Map();
  for (const g of groups) {
    for (const v of g) mapping.set(v, g);
  }

  // For each position, list the possible choices (if not in any group, the choice is itself)
  const choices = baseList.map(v => mapping.get(v) ?? [v]);

  // Quick necessary check: there must be at least as many distinct candidate values
  // across all positions as there are positions; otherwise impossible.
  const union = new Set(choices.flat());
  if (union.size < choices.length) return []; // impossible to assign unique numbers

  const seen = new Set(); // will store JSON-stringified sorted arrays to dedupe
  const result = [];

  function backtrack(i, current, used) {
    if (i === choices.length) {
      // canonicalize (order doesn't matter): sort and stringify
      const sorted = [...current].sort((a, b) => a - b);
      const key = JSON.stringify(sorted);
      if (!seen.has(key)) {
        seen.add(key);
        result.push(sorted);
      }
      return;
    }

    for (const cand of choices[i]) {
      if (used.has(cand)) continue; // ensure each number appears only once
      used.add(cand);
      current.push(cand);

      backtrack(i + 1, current, used);

      current.pop();
      used.delete(cand);
    }
  }

  backtrack(0, [], new Set());
  return result;
}


const identicalNodes = (topology, identicalParticleGroups) => {
    const particles = particleContent(topology);
    const groups = identicalParticleGroups.filter(group => group.length > 1).map(group => group.map(str => Number(str)));
    const variants = generateUniqueVariants(particles, groups);
   return variants.map(variant => {
       return getTopologyKey(variant);
   });
}


export { getTopologyKey, extractIsobars, particleContent, identicalNodes };